import { TopicsScores } from '@/domain/impact-calculate/entities/calculate.entity';
import { language } from '@/ui/i18n';

export function getScoreForMonth(
  scoresByMonth: Record<string, TopicsScores>,
  month: string,
) {
  if (scoresByMonth[month]) {
    return scoresByMonth[month];
  }
  return {
    co2: '-',
    env: '-',
    ess: '-',
    totalMen: '-',
    totalWomen: '-',
    totalOther: '-',
  };
}

export function getScoreForDate(
  scoresByDates: Record<number, TopicsScores>,
  dateId: number,
) {
  if (scoresByDates[dateId]) {
    return scoresByDates[dateId];
  }
  return { co2: '-', env: '-', ess: '-' };
}

export function formatDate(date: string) {
  return new Date(date).toLocaleDateString(language);
}

export function formatMonthName(date: string) {
  return new Date(date).toLocaleDateString(language, {
    month: 'long',
    year: '2-digit',
  });
}
